import { styleConfig } from "@chakra-ui/theme-tools";

var getColorStyles = function getColorStyles(c) {
  if (c === "base") {
    return {
      bg: "gray.300",
      color: "gray.800"
    };
  } else if (c === "dark") {
    return {
      bg: "gray.700",
      color: "white"
    };
  } else {
    return {
      bg: c + ".100",
      color: c + ".300"
    };
  }
};

var badge = styleConfig({
  baseStyle: {
    borderRadius: "md",
    fontWeight: "medium",
    paddingX: "6px"
  },
  variants: {
    solid: function solid(props) {
      var c = props.colorScheme;
      return Object.assign({}, getColorStyles(c));
    },
    rounded: function rounded(props) {
      var c = props.colorScheme;
      return Object.assign({}, getColorStyles(c), {
        borderRadius: "32px"
      });
    }
  },
  sizes: {
    lg: {
      height: "28px",
      lineHeight: "28px",
      fontSize: "md",
      px: "10px"
    },
    md: {
      height: "21px",
      lineHeight: "21px",
      fontSize: "sm",
      px: "8px"
    },
    sm: {
      height: "18px",
      lineHeight: "20px",
      fontSize: "xs"
    },
    xs: {
      height: "16px",
      lineHeight: "17px",
      fontSize: "2xs"
    }
  },
  defaultProps: {
    variant: "solid",
    colorScheme: "base",
    size: "md"
  }
});
export default badge;